import { ResearcherForm } from '@/features/researchers/components/ResearcherForm';
import { useResearcherForm } from '@/features/researchers/hooks/useResearcherForm';
import { useTranslation } from 'react-i18next';
import { FormWrapper } from '@/shared/components/forms';
import { useIsEditingSelf } from '@/features/researchers/hooks/useIsEditingSelf';

export const ResearcherEdit = () => {
  const { t } = useTranslation();
  const form = useResearcherForm();
  const isEditingSelf = useIsEditingSelf();

  return (
    <FormWrapper form={form} title={t('pages.users.create.title')}>
      <ResearcherForm form={form} hideRole={isEditingSelf} />
    </FormWrapper>
  );
};
